

export default function SliderIcon() {
    return (
    <svg width="22" height="6" viewBox="0 0 22 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame 42">
    <circle id="Ellipse 3" cx="14.5964" cy="2.90403" r="2.54808" fill="black"/>
    <path id="Vector 2" d="M21.3272 2.90405L0.17334 2.90405" stroke="black"/>
    </g>
    </svg> )
}
